const { invert, mapKeys } = require('lodash');

const jas = {
  asin: 'ASIN',
  sku: 'SKU', 
  sellerName: 'セラー',
  productName: '商品名',
  sales: '売上',
  cost: '原価',
  salesFees: '販売手数料',
  systemUsageFee: 'システム利用料',
  safetyFee: '安全性利用料',
  paymentFee: '決済手数料',
  fbaShippingCost: 'FBA配送料',
  shippingCost: '配送料',
  grossProfit: '純粗利益',
  grossProfitRate: '純粗利益率',
  adCost: '広告費',
  contributionMargin: '限界利益',
  contributionMarginRate: '限界利益率',
  adSales: '広告売上',
  adSalesRatio: '広告売上比率',
  organicSales: 'オーガニック売上',
  organicSalesRatio: 'オーガニック売上比率',
  grossSales: '総売上',
  vineSales: 'Vine売上',
  grossQuantity: '総販売数',
  refundQuantity: '返品数',
  vineQuantity: 'Vine販売数',
  fbaQuantity: 'FBA在庫数',
  fbaInventoryAmount: 'FBA在庫額',
  dailyAverageQuantity: '平均販売数/日',
  daysUntilStockout: '在庫切れ予測',
  acos: 'ACOS',
  acots: 'TACOS',
  month: '月',
  sales: '売上',
  refund: '売上返金',
  cods: '原価',
  grossProfit: '粗利',
  cods2: '原価2',
  grossProfit2: '純粗利',
  variableSga: '販管費(変動費)',
  contributionMargin: '限界利益',
  fixedSga: '販管費(固定費)',
  operatingProfit: '営業利益',
  amount: '金額',
  rate: '比率',
  itemName: '項目名',
  yearTotal: '年度合計',
  weekTotal: '週合計',
  productCost: '商品原価',
  importsCost: '輸入諸経費',
  commission: '販売手数料',
  fbaPerUnitFulfillmentFee: 'FBA費用',
  shippingCost: '配送料',
  inventoryFee: '在庫保管手数料',
  spAmount: '広告費',
  otherVariableCost: 'その他変動費',
  promotionCost: 'プロモ割引等',
  pointsCost: 'ポイント',
  pointsBaseCost: 'ポイント原資',
  couponFee: 'クーポン',
  pointFee: 'ポイント',
  promotionDiscount: 'プロモーション割引',
  timeSaleFee: 'セール費用',
  ecPlatformFee: '出店費用',
  otherFixedCost: 'その他固定費',
  sellerId: 'セラーID',
  ownerType: '種別',
  ownerId: 'ショップID',
  ownerName: 'ショップ',
  behavior: '区分',
  type: '費目',
  description: '内容',
  inboundDate: '納品日',
  productId: '商品ID',
  quantity: '数量',
  unitCost: '原価単価',
  unitShippingCost: '配送料単価',
  costTaxRate: '原価税率',
  memo: 'メモ',
};

const invertedJas = invert(jas);

const mapKeysToJa = (_, _jas = {}) => mapKeys(_, (v, k) => {
  const [, main, sub] = k.match(/^([^_]*)(.*)/) || [];
  return (({ ...jas, ..._jas })[main] || main) + sub;
});

const mapKeysFromJa = (_, _jas = {}) => mapKeys(_, (v, k) => {
  const [, main, sub] = k.match(/^([^_]*)(.*)/) || [];
  return (({ ...invertedJas, ..._jas })[main] || main) + sub;
});

const validations = {
  general: {
    required: '必須項目です',
    greaterThanOrEqualTo0: '0以上で指定してください。',
    greaterThan0: '1以上で指定してください。',
    lessThanOrEaualToX: '指定可能な数値を超えています',
    samePassword: 'パスワードと一致しません',
    format: '形式が正しくありません',
    inRange: '範囲内で指定してください',
    greaterThanStart: '開始時刻以降で指定してください',
    exclusive: '他と重なっています',
    minLength: '長さが不足しています',
    exists: '存在しません',
    finite: '数値を入力してください',
    requiredInSomeCase: '入力してください',
    unique: '他に存在します',
  },
};

exports.mapKeysToJa = mapKeysToJa;
exports.mapKeysFromJa = mapKeysFromJa;
exports.validations = validations;
exports.jas = jas;
exports.invertedJas = invertedJas;
